import script from "./gridMain.vue?vue&type=script&lang=js"
export * from "./gridMain.vue?vue&type=script&lang=js"

import "./gridMain.vue?vue&type=style&index=0&id=1cc70942&scoped=true&lang=css"
import "./gridMain.vue?vue&type=style&index=1&id=1cc70942&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc70942"]])

export default __exports__